import React from 'react';

import { useMatchMedia } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';
import { Box, Heading } from '@betterment/style-closet-react';

const Header: React.FC = () => {
  const isAtLeastMedium = useMatchMedia('atLeastMedium');

  return (
    <Box pt={isAtLeastMedium ? '10' : '9'} pb={isAtLeastMedium ? '8' : '3'} paddingX={isAtLeastMedium ? '0' : '8'}>
      <Heading as="h1" variant="primary" mr="10">
        Refer a friend
      </Heading>
      <Text
        as="p"
        color="text.weak"
        css={{
          marginBottom: 'space.0',
        }}
      >
        Get rewarded when your friends sign up for Betterment. Rewards are available for the first five referrals only.
      </Text>
    </Box>
  );
};

export default Header;
